import axios, { type AxiosResponse } from "axios";
import { defaultUrl } from "@/utils/url";
import { ElMessage } from "element-plus";
import { isToken, judgementShwo, removeCookie } from "@/utils/utils";
import { createStore } from "@/vuex/store";
import router from "@/router";
import { getAuthToken, isEmbedded, requestParentToken } from "@/utils/embeddedAuth";
// import { fa } from "element-plus/es/locale";
const store = createStore();
let token = "";

const service = axios.create({
  baseURL: defaultUrl,
  timeout: 10000 * 6,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});
const verifyLogin = false;
let showWarning = false;

const noTokenUrl: string[] = [
  "/api/chat/web/role/list",
  "/api/chat/web/role/group/list",
  "/api/wx/public/login/getWeChatPublicAccountImageBase64",
  "/api/wx/public/login/check/state",
  "/api/wx/OAuth/login/getAuthUrl",
  "/api/wx/OAuth/login/apply/token",
  "/api/get/verification/code",
  "/api/login",
  "/api/register",
  "/api/wx/public/login/check/bind/state",
  "/api/chat/web/app/user/getWeChatPublicAccountImageBase64ToBindAccount",
  "/api/wx/public/login/getWeChatPublicAccountImageBase64ToBindAccount",
  "/api/forget/password",
  // "/api/chat/web/app/all/ai/model/v2",
  "/api/chat/web/app/plugins/template/list",
  "/api/chat/web/announcement/list",
  "/api/chat/web/role/template/group/list",
  "/api/chat/web/role/template/list",
  "/api/chat/web/app/user/getProduct",
  "/api/chat/web/plugin/group/list",
  "/api/chat/web/model/list",
  "/api/chat/web/model/supplier/type/all/list",
  "/api/chat/web/app/template/detail",
  "/api/chat/web/app/role/detail",
  "/api/web/workflow/square/detail",
  "/api/web/plugin/form/detail",
  "/api/web/plugin/form/submit",
  "/api/get/companyInfo",
  "/api/web/maas/models",
  "/api/web/maas/models/detail",
  "/api/web/maas/oem/features",
  "/api/client/download/info"
];
// web集成的接口不报错
const noNoticeUrl: string[] = [
  "/api/web/integration/metadata",
  "/api/web/integration/chat",
  "/api/chat/web/exportInvokeRecord",
  "/api/chat/web/exportNotHitKnowledgeInvokeRecord",
  "/api/chat/web/exportTransferManualInvokeRecord",
  "/api/chat/web/export/highFrequencyWordRecord",
];
// 不需要显示错误提示的接口
const noErrorNoticeUrl: string[] = [
  "/api/chat/web/media/upload",
  "/api/chat/web/app/add",
  "/api/web/embedding",
  "/api/chat/web/app/user/sign/in",
  "/api/web/voice/stream",
  "/api/web/database/builtin/template_file",
  "/api/web/database/table/export",
  "/api/web/voice/read",
  "/api/control/msg/session/history/export",
  "/api/chat/web/media/export",
  "/api/wx/OAuth/login/apply/token",
  "/api/chat/web/superagent/status",
  // 空间（工作空间）接口，服务端未开放时由页面内占位提示接管
  "/api/control/workspace/tree",
  "/api/control/workspace/search",
  "/api/control/workspace/resolve",
  "/api/control/workspace/meta",
  "/api/control/workspace/read",
  "/api/control/workspace/file",
  // 技能规范校验可能一次返回多条问题，由页面用对话框完整展示
  "/api/chat/web/skill/market/upload",
  "/api/chat/web/skill/market/upload/check",
  "/api/chat/web/skill/market/draft/publish",
];
// 不需要显示错误提示的状态码
const noErrorNoticeCode: number[] = [701, 870, 440];
interface failCheck {
  [key: number]: string;
}
const statusMap: failCheck = {
  401: "身份过期，请重新登录",
  406: '您的余额不足，请点击右上角头像，前往 "我的账户" 查看',
  410: "图片生成失败，请检查提示词参数或内容",
  461: "作图任务未找到，请重试或联系客服处理",
  503: "当前服务不可用，请重试或联系客服处理",
  511: " 请耐心等待当前任务完成",
  561: "图片生成遇到了一点小问题，请重试一下吧",
  599: "未知异常，请重试或联系客服处理",
};

const pending: any = [];
const cancelToken = axios.CancelToken;
const removePending = (config: any) => {
  //查找数组中是否存在相同请求，存在则取消
  for (const p in pending) {
    if (pending[p].u === config.url.split("?")[0] + "&" + config.method) {
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //数组移除当前请求
    }
  }
};

service.interceptors.request.use(
  (config: any) => {
    removePending(config);
    let indexUrl = -1;
    let indexWebAppUrl = -1;
    if (
      config.url == "/api/control/msg/session/history" ||
      config.url == "/api/control/msg/session/list" ||
      config.url == "/api/web/hosting/group/list" ||
      config.url == "/api/chat/web/data/board/useUserCount" ||
      config.url == "/api/chat/web/data/board/recordCount" ||
      config.url == "/api/chat/web/data/board/recordNotHitKnowledgeBaseCount" ||
      config.url == "/api/chat/web/data/board/transferManualCount" ||
      config.url == "/api/chat/web/data/board/scoreCostCount" ||
      config.url == "/api/chat/web/data/board/recordChannelCount" ||
      config.url == "/api/web/voice/read" ||
      config.url === "/api/web/workflow/square/detail" ||
      (config.url === "/api/chat/web/app/role/detail" &&
        !config.params.allowCancel) ||
      config.url === "/api/chat/web/plugin/mcp/tools"
    ) {
      config.cancelToken = new cancelToken((c) => {
        // pending存放每一次请求的标识，config.url请求路径，config.params参数，config.method请求方法
        pending.push({
          u: config.url.split("?")[0] + "&" + config.method,
          f: c,
        });
      });
    }
    if (config.url) {
      indexUrl = noTokenUrl.indexOf(config.url);
      indexWebAppUrl = noNoticeUrl.indexOf(config.url);
    }
    // web集成的请求不显示报错信息。
    // 内嵌 iframe（超级助理）优先用隔离的 sessionStorage token，避免被独立的
    // 智能体平台登出（localStorage.clear）清掉；否则回退到标准 localStorage token。
    token = getAuthToken();

    if (!token && indexUrl === -1 && indexWebAppUrl === -1) {
      if (!isToken()) return;
      ElMessage({
        type: "warning",
        message: "请先登录",
      });
    }
    if (
      config.url == "/api/web/knowledge/base/website/parse" ||
      // 批量删除是逐个删的，每个都要清 ES、文件、绑定关系与素材，
      // 默认的 60 秒容不下一整批。删目录会连同目录里的知识库一起删，
      // 走的是同一条逐个删除的路径，超时也得一起放宽
      config.url == "/api/web/knowledge/base/batch/delete" ||
      config.url == "/api/web/knowledge/folder/delete" ||
      config.url == "/api/web/knowledge/folder/batch/delete"
    ) {
      config.timeout = 10000 * 6 * 3;
    }
    if (
      config.url == "/api/chat/web/plugin/add" ||
      config.url == "/api/chat/web/plugin/update"
    ) {
      config.timeout = 10000 * 6 * 5;
    }
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

service.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    let indexWebAppUrl = -1;
    if (response.config.url) {
      indexWebAppUrl = noNoticeUrl.indexOf(response.config.url);
    }
    if (response.data.code == 440) {
      ElMessage({
        type: "error",
        message: response.data.message,
        dangerouslyUseHTMLString: true,
      });
    }
    if (response.data.code === 401 && indexWebAppUrl === -1) {
      // Embedded iframe (super agent): do NOT clear storage / redirect to the
      // standalone login page. Just ask the embedder for a fresh token so the
      // embed stays independent of the standalone platform's login state.
      if (isEmbedded()) {
        requestParentToken();
        return response.data;
      }
      store.action.clearToken();
      store.action.updateUser({});

      // ElMessage({
      //   type: "warning",
      //   message: "请重新登录",
      // });
      let loginType = "password";
      if (localStorage.getItem("loginType")) {
        loginType = localStorage.getItem("loginType") || "password";
      }
      let loginActive = "first";
      if (localStorage.getItem("loginActive")) {
        loginActive = localStorage.getItem("loginActive") || "first";
      }
      let loginCompanyType = "code";
      if (localStorage.getItem("loginCompanyType")) {
        loginCompanyType = localStorage.getItem("loginCompanyType") || "code";
      }
      localStorage.clear();
      sessionStorage.clear();
      removeCookie("TOKEN_KEY");
      store.action.clearState();
      localStorage.setItem("showWebImportTip", "1");
      localStorage.setItem("privacyPolicy", "true");
      localStorage.setItem("privacyPolicy", "true");
      localStorage.setItem("loginType", loginType);
      localStorage.setItem("loginActive", loginActive);
      localStorage.setItem("loginCompanyType", loginCompanyType);
      isToken();
      if (!judgementShwo()) {
        router.push({ path: "/login" });
      }
    }
    // 返回这些将不会报错提示
    if (!response.data.success) {
      const url = response.config.url || "";
      const code = response.data.code;
      const isNoErrorNoticeUrl = noErrorNoticeUrl.includes(url);
      const isNoErrorNoticeCode = noErrorNoticeCode.includes(code);
      const isNoNoticeUrl = indexWebAppUrl !== -1;

      // 如果不在排除列表中，则显示错误提示
      if (!isNoErrorNoticeUrl && !isNoErrorNoticeCode && !isNoNoticeUrl) {
        ElMessage({
          type: "error",
          message: response.data.message,
        });
      }
    }
    if (
      response.config.url !== "/v1/img/web/midjourney/generate" &&
      response.config.url !== "/v1/img/web/midjourney/operate"
    ) {
      return response.data;
    } else {
      return response;
    }

    // throw new Error(response.status.toString());
  },
  (error) => {
    let indexWebAppUrl = -1;

    if (error.config && error.config.url) {
      indexWebAppUrl = noNoticeUrl.indexOf(error.config.url);
    }

    if (indexWebAppUrl === -1) {
      if (axios.isCancel(error)) {
        // 请求被取消
        console.log("请求被取消");
        return Promise.reject("cancel");
      } else {
        // 处理其他错误
        console.error("请求发生错误", error);
      }
      // error.config / error.response 在“请求还没发出去就失败”(如 dispatchRequest 阶段
      // 读取 cancelToken 失败、并发切 token 时 config 非法)时可能为 undefined。
      // 早期这里无保护地访问 error.config.url / error.response.status 会二次抛出
      // “Cannot read properties of undefined”，把一个可忽略的瞬时错误放大成“未知异常”弹窗
      // (扫码注册瞬间偶发)。这里统一做空值保护：拿不到 config/response 就当作可忽略的网络抖动，
      // 静默 reject，不弹窗、不跳登录。
      const errUrl = error.config?.url || "";
      if (
        error.message === "timeout of 60000ms exceeded" &&
        errUrl.indexOf("/v1/img/web/midjourney/tasks/") > -1
      ) {
        return;
      }
      if (!error.config || !error.response) {
        return Promise.reject(error);
      }
      const isPaint = errUrl.indexOf("/v1/img/web/midjourney");
      const status = error.response.status;
      if (error.response && status === 401) {
        // Embedded iframe: re-request token from the embedder instead of
        // clearing storage / redirecting (see the success-branch note above).
        if (isEmbedded()) {
          requestParentToken();
          return Promise.reject(error);
        }
        store.action.clearToken();
        store.action.updateUser({});

        // ElMessage({
        //   type: "warning",
        //   message: "请重新登录",
        // });
        let loginType = "password";
        if (localStorage.getItem("loginType")) {
          loginType = localStorage.getItem("loginType") || "password";
        }
        let loginActive = "first";
        if (localStorage.getItem("loginActive")) {
          loginActive = localStorage.getItem("loginActive") || "first";
        }
        localStorage.clear();
        sessionStorage.clear();
        removeCookie("TOKEN_KEY");
        store.action.clearState();
        localStorage.setItem("showWebImportTip", "1");
        localStorage.setItem("privacyPolicy", "true");
        localStorage.setItem("loginType", loginType);
        localStorage.setItem("loginActive", loginActive);
        isToken();
        if (!judgementShwo()) {
          router.push({ path: "/login" });
        }
      } else if (isPaint > -1) {
        ElMessage({
          type: "warning",
          message: statusMap[status],
        });
      } else {
        if (!showWarning) {
          ElMessage({
            type: "warning",
            dangerouslyUseHTMLString: true,
            message:
              "网络遇到一些问题，请点击刷新，或联系客服处理~<button id='mesbtn' style='height: 32px; line-height: 32px; margin-left: 15px; padding: 0 15px; border:1px solid #dcdfe6; background-color: #fff; color: #606266; cursor: pointer'>刷新</button>",
          });
          showWarning = true;
          const b = document.getElementById("mesbtn");
          if (b) {
            b.addEventListener("click", () => {
              window.location.reload();
            });
          }
          setTimeout(() => {
            showWarning = false;
          }, 3000);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default service;
